import axios from '@/libs/api.request'
import { genURLParams } from '@/libs/urlparamhelper'

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorderdevicerecord/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getUserGroupPage = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorderdevicerecord/getusergrouppage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}
